import { render } from "./EventPublicRegistration.vue?vue&type=template&id=6e07615c&scoped=true"
import script from "./EventPublicRegistration.vue?vue&type=script&lang=js"
export * from "./EventPublicRegistration.vue?vue&type=script&lang=js"

import "./EventPublicRegistration.vue?vue&type=style&index=0&id=6e07615c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e07615c"]])

export default __exports__